<template>
  <div
    class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
    v-if="noteModal"
    :class="{ show: noteModal }"
  >
    <div class="cstm-modal medium fixed_medium">
      <div class="header">
        <h4>{{ fileType }}</h4>
        <button @click.stop="closePopupNoteModal" class="close-modal">
          &times;
        </button>
      </div>
      <div class="modal-content p-4">
        <div class="flex flex-wrap justify-between items-center mb-2">
          <h5>{{fileType}} List</h5>

          <vs-tooltip text="Add New" color="primary">
            <vs-button
              type="border"
              color="primary"
              icon="add"
              @click="addNewNoteModal"
            />
          </vs-tooltip>
        </div>
        <div 
          style="max-height: 300px; overflow: auto"
          class="vertical_scrollbar border_btm pb-4"
          @scroll="detectsScrollLength()"
            ref="element"
        >
          <vs-table v-if="topic_list.length > 0"
            style="max-height: 300px"
            class="cstm_vuexy_table vertical_scrollbar"
             :data="topic_list"
            
          >
            <template slot="thead">
              <vs-th></vs-th>
              <vs-th>Title</vs-th>
              <vs-th>Description</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td
                  ><input
                    type="radio"
                    class="cursor-pointer"
                    name="picked"
                    @click="selectFile(data[indextr])"
                /></vs-td>
                <vs-td :data="data[indextr].note[0].title">
                  {{ data[indextr].note[0].title }}
                </vs-td>
                <vs-td :data="data[indextr].note[0].description">
                  {{ data[indextr].note[0].description }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <div v-else class="flex flex-col justify-center items-center my-6">
            <img
              src="https://scoolio-files.s3.ap-south-1.amazonaws.com/Scoolio/no_coursework.png"
              alt="nodata"
            />
            <p class="text-center">No Coursework found</p>
          </div>          
        </div>
        <vs-button class="block mx-auto mt-4" @click="exportToCourse">Export to Coursebuilder</vs-button>   

        <div v-if="addNewNote">
        <NoteCreationForCourse :fileType="type" :addNewNote="addNewNote" @createTopic="createTopic" @closeCreateModal="closeCreateModal" />
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
import NoteCreationForCourse from '@/views/pages/v1/coursebuilder/components/NoteCreationForCourse.vue'


export default {
  components: {
    NoteCreationForCourse
  },
 
  name: 'FileModalComponent',
  props: {
    noteModal: {
      default: false
    },
    fileType: {
      default: ''
    },
    topic_list: {
      default: []
    }
  },

  data () {
    return {
      addFileModal:false,
      selected: [],
      file_link: null,
      customer_id: localStorage.getItem('customer_id'),
      preview_video: null,
      addNewNote: false,
      type: ''
      
     
    }
  },

  methods: {
    addNewNoteModal () {
      this.addNewNote = true
      this.type = 'Add'
    },
    exportToCourse () {
      console.log(this.selected)
      this.$emit('exportToCourse', this.selected)
    },
    selectFile (data) {
      console.log(data)
      this.selected = data
    },
    detectsScrollLength () {
      console.log(this.$refs.element.scrollTop + this.$refs.element.offsetHeight)
      console.log(this.$refs.element.scrollHeight)
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight
      ) {
        this.loadMoreMedia()
      }
    },
    async loadMoreMedia () {
      this.$emit('loadMoreTopic', this.fileType)
    },
    closePopupNoteModal () {
      this.$emit('closeModal', true)
    },
    closeCreateModal () {
      this.addNewNote = false
    },
    createTopic (topicObject) {
      this.$emit('createTopic', topicObject)
    }
    
  }
}
</script>
